import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButton from 'components/action-button';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.$8,
    paddingHorizontal: spacing.$8,
    paddingTop: spacing.$4,
  },
  title: {
    margin: 0,
    textAlign: 'center',
  },
  body: {
    textAlign: 'center',
  },
});

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const Title = withTypography({
  fontFamily: 'heading',
  variant: 'headerFour',
  style: styles.title,
});

export const Body = withTypography({ m: '$0', style: styles.body });

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  marginTop: '$6',
  fontSize: 'lg',
  width: 'full',
});
